export var FILE_FORMATS = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  PDF: 'pdf',
  PRESENTATION: 'presentation',
  MSWORD: 'msword',
  SPREADSHEET: 'spreadsheet',
  TEXT: 'text',
  WEBLINK: 'web',
  ASSET: 'asset'
};
export var DOCUMENT_CONTENT_TYPES = [FILE_FORMATS.PDF, FILE_FORMATS.PRESENTATION, FILE_FORMATS.MSWORD, FILE_FORMATS.SPREADSHEET, FILE_FORMATS.TEXT];
export var MEDIA_CONTENT_TYPES = [FILE_FORMATS.IMAGE, FILE_FORMATS.VIDEO, FILE_FORMATS.AUDIO];
export var CONTENT_TYPES = {
  PLAYLIST: 'playlist',
  SECTION: 'section',
  FOLDER: 'folder',
  TOPIC: 'topic',
  UPLOAD: 'upload',
  WEBLINK: 'web',
  MICROSITE: 'zip',
  SCORM: 'scorm',
  FILE: 'file'
};
export var IFRAME_CONTENT_TYPES = [CONTENT_TYPES.SCORM, CONTENT_TYPES.WEBLINK, CONTENT_TYPES.MICROSITE];

// we were tracking this for microsites as well, but had issues with injecting the html in cloudfront gate so removed it
export var IFRAME_TRACK_OPENS_ASSET_TYPES = [CONTENT_TYPES.SCORM];
export var ASSET_TYPES = [CONTENT_TYPES.UPLOAD, CONTENT_TYPES.WEBLINK, CONTENT_TYPES.MICROSITE, CONTENT_TYPES.SCORM];